import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Form from '../../views/Form';
import Home from '../../views/Home';
import FindRange from '../../views/FindRange';

function App() {
  return (
    <div>
      <Router>
        <Switch>
          <Route path="/edit-range/find-range">
            <FindRange />
          </Route>
          <Route path="/edit-range/form/:id">
            <Form />
          </Route>
          <Route path="/">
            <Home />
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
